import template from './leave_cancellation_reject.html';
import tr from '../../lib/default-translator.js';

class LeaveCancellationRejectViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	}

	close()
	{
		this.dialog.close(false);
	}

	async save_reject()
	{
		// Validate
		if ($('#txtRejectionReason').val() == '')
		{
			Grape.alerts.alert({type: 'error', message: tr('Please give a valid reason for rejecting'), title: tr('Error')});
			return;
		}

		let data = {
			transaction_id: this.dialog.bindings.transaction_id,
			rejection_reason: $('#txtRejectionReason').val()
		};

		let res = await Grape.fetches.postJSON('/manager/reject_leave_cancellation', data);
		if (res.status == 'OK')
		{
			Grape.alerts.alert({type: 'success', message: tr('Successfully rejected leave cancellation.'), title: tr('Success')});
			this.dialog.close(false);
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({type: 'error', 	message: tr('Something went wrong...'), title: tr('Error')});
	};
};

class LeaveCancellationRejectPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveCancellationRejectViewModel(this);
		this.bindings = bindings;

		$('#reject_dialog').on('keypress', (e) => {
			var code = (e.keyCode ? e.keyCode : e.which);
			if (code == 13) { //Enter keycode
				document.getElementById("btn_accept").click();
			}
		});
	};
};

export default {
	name: 'LeaveCancellationReject',
	dialog_class: LeaveCancellationRejectPage,
	template: template,
	template_filename: 'translation/dialogs/leave_cancellation_reject',
	provider: 'ps'
};
